module.exports = __webpack_public_path__ + "img/luna creciente.9daf3e69.svg";